var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyPublished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 136,
    viewBox: "0 0 210 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_441_31711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.989 78.232H76.3203V2.55054H208.989V78.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.5 78.7428H75.8096V2.03979H209.5V78.7428ZM76.8311 77.7213H208.478V3.06129H76.8311V77.7213Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.695 56.3231C152.522 56.3231 158.866 49.9783 158.866 42.1516C158.866 34.325 152.522 27.9802 144.695 27.9802C136.868 27.9802 130.523 34.325 130.523 42.1516C130.523 49.9783 136.868 56.3231 144.695 56.3231Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.412 43.1332C146.264 41.8161 145.18 39.6913 144.544 37.9788C143.909 39.6913 142.825 41.8161 141.677 43.1332L144.243 42.2049V47.9289H144.846V42.2049L147.412 43.1332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.921 5.26422H123.496V0.439941H147.921L150.331 2.85221L147.921 5.26422Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.799 5.26422H99.375V0.439941H123.799L126.21 2.85221L123.799 5.26422Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9792 5.26422H75.5547V0.439941H99.9792L102.39 2.85221L99.9792 5.26422Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78223 135.117L4.85764 134.78C4.87435 134.706 6.58199 127.321 12.2134 123.188C17.845 119.055 25.4014 119.64 25.477 119.646L25.8214 119.675L25.746 120.012C25.7293 120.086 24.0216 127.471 18.3903 131.604C12.7586 135.737 5.2022 135.152 5.12667 135.146L4.78223 135.117ZM12.5702 123.674C7.80882 127.169 5.94242 133.076 5.53571 134.564C7.07715 134.621 13.2767 134.609 18.0334 131.118C22.7897 127.627 24.6598 121.717 25.0679 120.228C23.5256 120.171 17.3267 120.183 12.5702 123.674Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6998 125.4C11.9728 131.796 5.23808 135.052 5.23808 135.052C5.23808 135.052 2.92464 127.938 5.65159 121.542C8.37853 115.146 15.1133 111.889 15.1133 111.889C15.1133 111.889 17.4267 119.003 14.6998 125.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6622 54.4945C84.4118 54.1315 84.085 53.8277 83.7046 53.6047C83.3242 53.3817 82.8995 53.2448 82.4605 53.2036C82.0214 53.1625 81.5787 53.2181 81.1635 53.3666C80.7483 53.515 80.3707 53.7527 80.0573 54.0629L73.7015 51.3958L71.1387 54.8628L80.1671 58.5033C80.7231 58.9953 81.4403 59.2662 82.1827 59.2647C82.9251 59.2633 83.6412 58.9896 84.1953 58.4954C84.7493 58.0013 85.1029 57.3211 85.1889 56.5837C85.275 55.8463 85.0876 55.1029 84.6622 54.4945Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3269 131.377L76.2094 131.377L76.5863 117.568L72.3262 116.402L72.3269 131.377Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3369 130.109L78.983 130.109H78.9833C80.2756 130.109 81.515 130.623 82.4288 131.536C83.3426 132.45 83.856 133.689 83.856 134.982V135.14L71.3371 135.141L71.3369 130.109Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.156 131.377L47.0385 131.377L48.8856 116.401L43.1553 116.402L43.156 131.377Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.165 130.109L49.8112 130.109H49.8115C51.1038 130.109 52.3431 130.623 53.2569 131.536C54.1707 132.45 54.6841 133.689 54.6842 134.982V135.14L42.1653 135.141L42.165 130.109Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4902 45.1572L79.3199 52.4267L77.0496 58.2157C77.0496 58.2157 69.1452 54.4065 68.6259 54.6757C68.1066 54.9448 66.4902 45.1572 66.4902 45.1572Z",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0234 67.0268L49.0986 94.8123L40.3242 126.85L47.6362 128.019L68.6946 83.4056L64.8924 59.4224L58.4579 57.0825L52.0234 67.0268Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3438 66.7343C47.3438 66.7343 54.6566 71.0304 57.0415 79.3776C59.5952 88.3158 64.3075 102.124 64.3075 102.124L70.742 128.312L78.639 126.265L69.2796 66.7343L61.3827 60.0073L51.146 58.8374L47.3438 66.7343Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3667 20.9723C69.0819 20.9723 72.0937 17.9605 72.0937 14.2453C72.0937 10.5301 69.0819 7.51831 65.3667 7.51831C61.6514 7.51831 58.6396 10.5301 58.6396 14.2453C58.6396 17.9605 61.6514 20.9723 65.3667 20.9723Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9662 27.2496C65.9662 27.2496 61.1358 21.9377 57.3336 21.9377C56.1115 21.9377 47.6049 31.4161 47.3375 38.2622L44.6152 68.4891C44.6152 68.4891 70.9383 69.9515 71.2308 68.7816C71.5233 67.6116 65.9662 27.2496 65.9662 27.2496Z",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0158 17.1858C62.5554 17.1536 63.0823 17.3359 63.6181 17.4071C64.5828 17.5045 65.5505 17.253 66.3457 16.6983C67.141 16.1436 67.7112 15.3223 67.953 14.3834C67.9869 14.1321 68.0618 13.8881 68.1747 13.661C68.4697 13.1793 69.1417 13.0874 69.6956 13.1982C70.2496 13.309 70.7747 13.5682 71.3388 13.5978C71.7764 13.5995 72.2068 13.487 72.5876 13.2715C72.9684 13.0559 73.2864 12.7448 73.5103 12.3688C73.949 11.607 74.1355 10.726 74.0433 9.85176L73.6257 10.29C73.456 9.93105 73.3905 9.53167 73.4366 9.13731C73.2153 9.07838 72.9826 9.07724 72.7608 9.13401C72.5389 9.19077 72.3354 9.30354 72.1696 9.46151C71.8014 9.50069 72.0793 8.77857 71.8058 8.52902C71.6727 8.44728 71.5142 8.41761 71.3606 8.44572C70.5773 8.45328 69.9436 7.85416 69.3264 7.37187C68.2569 6.53808 67.0063 5.96762 65.6755 5.70658C64.7932 5.49729 63.8697 5.54205 63.0117 5.8357C62.3346 6.13967 61.7234 6.57318 61.2127 7.11181C59.8995 8.37459 58.7366 9.8583 58.1903 11.5963C57.7461 13.0199 57.7335 14.5432 58.1541 15.9739C58.3742 16.7169 59.0377 19.2615 60.009 19.3208C61.2295 19.3952 60.4967 17.2764 62.0158 17.1858Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.27 34.5505L53.3816 44.6534L51.1787 68.1211L60.27 34.5505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2722 77.2365C50.5707 76.9119 50.7944 76.5258 50.9275 76.1055C51.0607 75.6851 51.1 75.2406 51.0428 74.8034C50.9856 74.3662 50.8332 73.9468 50.5964 73.5748C50.3596 73.2028 50.0441 72.8873 49.6722 72.6505L50.864 65.8616L46.9151 64.1311L45.3666 73.742C45.0101 74.3932 44.9049 75.1525 45.0709 75.8762C45.2369 76.5998 45.6626 77.2374 46.2672 77.6681C46.8719 78.0988 47.6136 78.2928 48.3517 78.2133C49.0898 78.1337 49.7732 77.7862 50.2722 77.2365Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0272 25.0493L46.9908 47.8755C46.9908 47.8755 44.3775 62.4212 45.5474 64.761C46.7173 67.1008 44.4189 71.7063 44.4189 71.7063L51.146 72.2912L54.4162 48.3862L60.2128 30.1743C60.2128 30.1743 62.5091 23.5869 54.0272 25.0493Z",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4948 42.2251L78.1885 67.6853L99.1486 72.0538L104.455 46.5936L83.4948 42.2251Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7869 42.8482L78.7051 67.2312L98.588 71.3751L103.67 46.9922L83.7869 42.8482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3186 46.2485L88.1699 46.9619L93.1613 48.0022L93.3099 47.2888L88.3186 46.2485Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8821 48.343L87.7334 49.0564L97.8901 51.1732L98.0387 50.4598L87.8821 48.343Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6184 50.3691L87.4697 51.0825L94.9146 52.6342L95.0633 51.9208L87.6184 50.3691Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.01 52.5259L86.8613 53.2393L89.3345 53.7547L89.4832 53.0413L87.01 52.5259Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5647 54.6636L86.416 55.377L92.4404 56.6325L92.5891 55.9192L86.5647 54.6636Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1165 56.8144L85.9678 57.5278L90.9591 58.5681L91.1078 57.8547L86.1165 56.8144Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6799 58.9087L85.5312 59.6221L95.6879 61.7389L95.8366 61.0255L85.6799 58.9087Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4163 60.9351L85.2676 61.6484L92.7125 63.2001L92.8611 62.4867L85.4163 60.9351Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8079 63.0918L84.6592 63.8052L87.1324 64.3206L87.2811 63.6073L84.8079 63.0918Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3625 65.2295L84.2139 65.9429L90.2383 67.1985L90.3869 66.4851L84.3625 65.2295Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0531 135.56H0.755375C0.687645 135.56 0.622689 135.533 0.574797 135.485C0.526905 135.437 0.5 135.372 0.5 135.305C0.5 135.237 0.526905 135.172 0.574797 135.124C0.622689 135.076 0.687645 135.049 0.755375 135.049H98.0531C98.1208 135.049 98.1858 135.076 98.2337 135.124C98.2816 135.172 98.3085 135.237 98.3085 135.305C98.3085 135.372 98.2816 135.437 98.2337 135.485C98.1858 135.533 98.1208 135.56 98.0531 135.56Z",
    fill: "#CACACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_441_31711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 135.12,
    fill: "white",
    transform: "translate(0.5 0.439941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPublished);
export default __webpack_public_path__ + "static/media/empty-published.73a723de1f51b5edd7ba7cc955e5b736.svg";
export { ForwardRef as ReactComponent };